module.exports = __webpack_public_path__ + "assets/img/企业简介_05.9cb09c54.jpg";